import { AccountCardData, AccountCardDetails } from './types';
import { useStyles } from './style';
import { MouseEventHandler } from 'react';

interface IConnectedAccountsCardProps {
    accountDetails: AccountCardDetails;
    accountData?: AccountCardData;
    isConnected?: boolean;
    buttonDisabled?: boolean;
    onConnectButtonClick?: MouseEventHandler<HTMLButtonElement>;
    onDisconnectButtonClick?: MouseEventHandler<HTMLButtonElement>;
    onSelectAccount?: MouseEventHandler<HTMLDivElement>;
}

const ConnectedAccountsCard = ({
    accountDetails,
    accountData,
    isConnected = false,
    buttonDisabled,
    onConnectButtonClick,
    onDisconnectButtonClick,
    onSelectAccount,
}: IConnectedAccountsCardProps) => {
    const classes = useStyles();
    const { icon, title, subTitle, description } = accountDetails;
    return (
        <div className={classes.accountCard}>
            <div className={classes.cardTop}>
                <div className={classes.cardTopLeft} onClick={isConnected ? onSelectAccount : undefined}>
                    <img src={icon} alt="" className={classes.accountIcon} />
                    <div className={classes.accountDetails}>
                        <h5 className={classes.accountTitle}>
                            {isConnected && accountData?.email
                                ? accountData?.email.length > 15
                                    ? accountData?.email?.slice(0, 14) + '..'
                                    : accountData?.email
                                : title}
                        </h5>
                        <p className={classes.accountSubTitle}>
                            {isConnected && accountData?.eventName ? accountData?.eventName : subTitle}{' '}
                        </p>
                    </div>
                </div>
                <button
                    className={isConnected ? classes.disConnectButton : classes.connectButton}
                    disabled={buttonDisabled}
                    onClick={!isConnected ? onConnectButtonClick : onDisconnectButtonClick}
                >
                    {isConnected ? 'Disconnect' : 'Connect'}
                </button>
            </div>
            {!isConnected && (
                <div className={classes.cardBottom}>
                    <p>{description}</p>
                </div>
            )}
        </div>
    );
};

export default ConnectedAccountsCard;
